import { render, staticRenderFns } from "./RoomsLayout.vue?vue&type=template&id=64353040&scoped=true&"
import script from "./RoomsLayout.vue?vue&type=script&lang=js&"
export * from "./RoomsLayout.vue?vue&type=script&lang=js&"
import style0 from "./RoomsLayout.vue?vue&type=style&index=0&id=64353040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64353040",
  null
  
)

export default component.exports